module.exports = __webpack_public_path__ + "static/media/logo3.08253535.png";